// https://vuex.vuejs.org/en/actions.html
import router from "../router";

export default {
  updateAccessOpenaiConfig({ commit }, accessOpenaiConfig) {
    return new Promise((resolve) => {
      if (accessOpenaiConfig?.value !== undefined) {
        commit("SET_ACCESS_OPENAI_CONFIG", accessOpenaiConfig.value);
        localStorage.setItem(
          "access_openai_config",
          JSON.stringify(accessOpenaiConfig.value)
        );
        resolve(accessOpenaiConfig.value);
      } else {
        const storedValue = JSON.parse(
          localStorage.getItem("access_openai_config")
        );
        if (storedValue !== null) {
          commit("SET_ACCESS_OPENAI_CONFIG", storedValue);
        }
        resolve(storedValue);
      }
    });
  },
  setEmojiHistory: ({ commit }, emojiHistory) => {
    emojiHistory.showing = true;
    commit("SET_EMOJI_HISTORY", emojiHistory);
  },
  setSnackbar: ({ commit }, snackbar) => {
    snackbar.showing = true;
    //snackbar.timeout = snackbar.timeout
    commit("SET_SNACKBAR", snackbar);
  },
  setAddToCard: ({ commit }, AddToCard) => {
    AddToCard.showing = true;
    commit("SET_AddToCard", AddToCard);
  },
  setAttachBox: ({ commit }, AttachBox) => {
    AttachBox.showing = true;
    commit("SET_ATTACHBOX", AttachBox);
  },
  setEmailDetectBox: ({ commit }, EmailDetectBox) => {
    EmailDetectBox.showing = true;
    commit("SET_EMAILDETETC", EmailDetectBox);
  },
  setPurchaseProducts: ({ commit }, PurchaseProducts) => {
    PurchaseProducts.showing = true;
    commit("SET_PurchaseProducts", PurchaseProducts);
  },
  setLoader: ({ commit }, loading) => {
    commit("SET_LOADER", loading);
  },
  setCloader: ({ commit }, Cloader) => {
    commit("SET_C_LOADER", Cloader);
  },
  setNotification: ({ commit }, notification) => {
    commit("SET_NOTIF", notification);
  },
  setInfocard: ({ commit }, infocard) => {
    commit("SET_INFOCARD", infocard);
  },
  setSysExport: ({ commit }, data) => {
    console.log(data);
    const showing = data?.showing || false;
    commit("SET_SYSTEM_EXPORT", showing);
  },
  route_push_toMsg({ commit }) {
    if (router.history.current.fullPath !== "/messages")
      router.push("/messages");
  },
  SOCKET_reciveMessage_actions: ({ commit, dispatch, rootState }, data) => {
    dispatch("GET_USER_BY_GUID", data.user.guid).then((r) => {
      data.user.id = r.id;
      rootState.user.users[data.user.guid] = data.user;
      if (rootState.show.dash) {
        commit("MsgNotification", { data, rootState });
      } else {
        commit("MsgNotification", { data, rootState });
        commit("reciveMessage", data);
      }
    });
  },
  SOCKET_ShopifyNewInstallation({ dispatch }, { storeId }) {
    dispatch("setLoader", {
      showing: true,
      text: "Fetch shopify access infos",
    });
    dispatch("FETCH_SHOPIFY_ACCESS_INFOS")
      .then(() => {
        dispatch("setLoader", {
          showing: false,
        });
        dispatch("setNotification", {
          showing: true,
          text: "Shopify App installed",
          position: "top-right",
          type: "info",
          timeout: 6000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.5,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: {
            iconClass: "v-icon mdi mdi-check-all",
            iconChildren: "",
            iconTag: "i",
          },
          rtl: false,
        });
      })
      .catch((err) => {
        console.log("store no shopify");
        dispatch("setLoader", {
          showing: false,
        });
      });
  },

  SOCKET_ShopifyApplicationDelert({ dispatch }, { storeId }) {
    dispatch("setLoader", {
      showing: true,
      text: "Fetch shopify access infos",
    });
    dispatch("FETCH_SHOPIFY_ACCESS_INFOS")
      .then(() => {
        dispatch("setLoader", {
          showing: false,
        });
        dispatch("setNotification", {
          showing: true,
          text: "Shopify application removed",
          position: "top-right",
          type: "info",
          timeout: 6000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.5,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: {
            iconClass: "v-icon mdi mdi-close",
            iconChildren: "",
            iconTag: "i",
          },
          rtl: false,
        });
      })
      .catch((err) => {
        console.log("store no shopify");
        dispatch("setLoader", {
          showing: false,
        });
      });
  },
};
